// extracted by mini-css-extract-plugin
export default {"scale":"KXxBj","appendScale":"q1n5E","unlimited":"rxkMQ"};